const scroll_btn = document.querySelector('.js-scroll-to-top');

if(scroll_btn != null){
    scroll_btn.addEventListener('click', ()=>{
        window.scrollTo(0,0);
    });
}